module.exports = __webpack_public_path__ + "static/media/phrase-eureka.7922e92f.svg";